<template>
  <div class="posts">
    <div class="wrapper">
      <div class="posts__inner">
        <div class="posts__layout">
          <h2 class="posts__title">Необходимо</h2>
          <div class="posts__posts">
            <div
              class="posts__item post"
              v-for="({ title, text, summ, currency }, index) in posts"
              :key="index"
            >
              <header>
                <h3 class="post__title">{{ title }}</h3>
                <p class="post__text">{{ text }}</p>
              </header>
              <footer>
                <div class="post__offer">
                  <div class="post__offer-icon">
                    <img src="@/assets/images/svg-defs/coins-dark.svg" alt />
                  </div>
                  <div class="post__offer-text">
                    <strong>
                      <small>Необходимо</small>
                    </strong>
                    <p>
                      <strong>{{ summ }}&nbsp;</strong>
                      <strong>{{ currency }}</strong>
                    </p>
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Posts",
  data: () => ({
    posts: [
      {
        title: "Система подогрева песка",
        text: "Оборудование, подключение, подвод 3 фазы",
        summ: "7500",
        currency: "лари"
      },
      {
        title: "Система вентиляции",
        text: "С проектом, закупкой оборудования и монтажом",
        summ: "15000",
        currency: "лари"
      },
      {
        title: "Система видеонаблюдения",
        text: "Закрытые системы кабельного телевидения",
        summ: "6500",
        currency: "лари"
      },
      {
        title: "Бассейн",
        text: "Включая отапливаемый павильон под бассейн",
        summ: "15000",
        currency: "лари"
      },
      {
        title: "Газовый генератор",
        text: "Общей мощностью 30 кВт с гарантией",
        summ: "25000",
        currency: "лари"
      },
      {
        title: "Оборудование для кабинетов",
        text: "Единичная покупка + расходники",
        summ: "20000",
        currency: "лари"
      },
      {
        title: "Микроавтобус на 8-10 мест",
        text: "Категории В, для перевозки групп детей или материалов",
        currency: "не указано"
      },
      {
        title: "Ипотека",
        text: "Необходимо закрыть ипотеку центра",
        summ: "20000",
        currency: "$"
      }
    ]
  })
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.posts {
  &__inner {
    padding: 40px 0;
  }

  &__layout {
    background-color: $sec_bg;
    border-radius: 30px;
    box-shadow: 0 0 2.5px 1px rgba($color: #000, $alpha: 0.1);
  }

  &__title {
    margin: 0 0 30px;
    font-size: 26px;
  }

  &__posts {
    display: flex;
    flex-wrap: wrap;
  }

  @media screen and (min-width: $min-lg) {
    &__layout {
      padding: 45px;
    }
  }

  @media screen and (max-width: $max-md) {
    &__layout {
      padding: 35px 20px;
    }
  }
}

.post {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px;
  margin-bottom: 30px;
  background-color: $sec_bg;
  border-radius: 20px;
  box-shadow: 0 0 2px 1px rgba(#333, 0.1);
  transition: box-shadow 0.4s;

  &__title {
    font-size: 22px;
    font-weight: $bl_fw;
    line-height: 1.2;
  }

  &__text {
    margin: 20px 0;
  }

  footer {
    padding: 20px 0 0;
    border-top: 1.5px solid darken($prim_bg, 5%);
  }

  &__offer {
    display: flex;
    align-items: center;
    padding: 15px 10px;
    background-color: $prim_bg;
    border-radius: 15px;

    strong {
      font-weight: $bl_fw;
      text-transform: uppercase;
    }

    p {
      line-height: 1.1;

      strong:first-child {
        font-size: 22px;
      }

      strong:last-child {
        font-size: 12px;
        text-transform: uppercase;
      }
    }

    &-icon {
      min-width: 36px;
      margin: 0 10px;
    }
  }

  &:hover {
    box-shadow: 0 5px 10px 1px rgba(#555, 0.1);
  }

  @media screen and (min-width: $min-lg) {
    flex-basis: calc((100% / 3) - 20px);

    &:nth-child(3n + 1) {
      margin-right: 15px;
    }

    &:nth-child(3n + 2) {
      margin-right: 15px;
      margin-left: 15px;
    }

    &:nth-child(3n + 3) {
      margin-left: 15px;
    }
  }

  @media screen and (min-width: $min-md) and (max-width: $max-md) {
    flex-basis: calc((100% / 2) - 15px);

    &:nth-child(2n + 1) {
      margin-right: 15px;
    }

    &:nth-child(2n + 2) {
      margin-left: 15px;
    }
  }

  @media screen and (max-width: $max-sm) {
    flex-basis: 100%;
    margin-bottom: 30px;
  }
}
</style>
